import { Chip } from "@mui/material";

const PreferredBadge = () => (
  <Chip
    label="Preferred"
    size="small"
    color="primary"
    sx={{ fontSize: 10, height: 20, lineHeight: 1 }}
  />
);

export default PreferredBadge;
